import Component from 'inferno-component';
import Page from '../components/Page';
import '../assets/styles/index.css';

class About extends Component {
  render() {
    return (
      <Page title="About the Developer">
        <div className="about__container">
          <h2 className="about__header">
            Ka‘ōnohi‘ulaokamanō Kai (1962-2013)
          </h2>
          <div className="about__body">
            <p>
              Kaʻōnohi‘ulaokamanō, he ake, he akeakamai, he koa kū hoʻokahi i ka hoʻoulu a hoʻolaha ʻana i nā ʻōlelo ʻōiwi no kona lāhui ponoʻī a me nā ʻōlelo ʻōiwi no nā lāhui o nā ʻāina ʻē.  ʻO ka papahana lolouila kūpaianaha nō hoʻi kēia āna iho, a kēia manō i ‘au i nā kai ʻewalu i mālama mai ai. ʻOiai he mau ʻōlelo kahiko kāna i hoʻoulu a hoʻolaha ai, na ka leo o ka lolouila e mālama mau no ia mau lāhui a mau loa aku.
            </p>
            <p>
              Na Kaʻōnohiʻulaokamanō nō i haku i kēia polokalamu ʻo Manomano, a hoʻomaikaʻi kākou i nā makahiki ʻumi a ʻoi o kāna kuʻupau ʻana i ka hana i mea e hoʻoholomua ai i ka lāhui Hawaiʻi. No laila, kaʻana ʻia maila kēia polokalamu me ka mahalo piha a me ke aloha palena ʻole hoʻi iā Kaʻōnohiʻulaokamanō Kai (1962-2013), he manō ʻau mau i ke kai ākea o nā ʻaumākua.
            </p>
            <p>
              Kaʻōnohi‘ulaokamanō, a desire, a seeker of knowledge, a scholar, a warrior revitalizing the native languages for his own nations and for those who live in other nations. His astonishing work in developing unicode products for more than 30 native languages will be preserved for generations to come.  As long as this technology is available, the voices of these nations will live on.
            </p>
            <p>
              We celebrate his decade of work as the developer of Manomano, a Hawaiian dictionary web application, and as a contributor to propel the Hawaiian language movement forward.  We share this work with our sincere gratitude and aloha to Ka‘ōnohi‘ulaokamanō Kai (1962-2013), a messenger who will continue swimming in the sea of the ancestors.
            </p>
          </div>
        </div>
      </Page>
    );
  }
}

export default About;



// WEBPACK FOOTER //
// ./src/pages/About.js